import React from 'react';
import { DisplayImage } from 'helper/products/meteorology';
import './index.scss';
import useImageRowSize from 'utils/hooks/meteorology/useImageRowSize';
import MeteorologyFieldsImage from './Image';

export default function MeteorologyFieldsRow({
  images,
  label,
  showImageLabels,
  selectSet,
  setImageIndex,
} : {
  images: DisplayImage[],
  label: string | undefined,
  showImageLabels: boolean,
  selectSet: () => void,
  setImageIndex: React.Dispatch<React.SetStateAction<number | undefined>>;
}) {
  const { rowSize } = useImageRowSize();
  const width = `${96 / rowSize}%`;

  const imageTitleSizes = images.map((img) => {
    const titleImpact = rowSize * 2 + img.title.length;

    if (titleImpact < 30) return 'l';
    if (titleImpact < 40) return 'm';
    if (titleImpact < 50) return 's';
    return 'xs';
  });

  return (
    <div className="mb-3 position-relative">
      {showImageLabels && (
        <div className="d-flex justify-content-between">
          {images.map((image, i) => (
            <p
              key={image.key}
              className={`meteorology-fields-display-row-image-label mb-2 display-image-title-${imageTitleSizes[i]}`}
              style={{ width }}
            >
              {image.title}
            </p>
          ))}
        </div>
      )}
      <div className="d-flex justify-content-between">
        {images.map((image, i) => (
          <div
            key={image.key}
            style={{ width }}
            className="flex-shrink-0"
          >
            <MeteorologyFieldsImage
              image={image}
              selectImage={() => {
                selectSet();
                setImageIndex(i);
              }}
            />
          </div>
        ))}
      </div>
      <span className="meteorology-fields-row-label text-center">
        {label}
      </span>
    </div>
  );
}
